export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6160.ef4c117f.jpg";